
export default function getOppositeDirection<T>(
  directionList: ReadonlyArray<T>,
  directionLike: T
): T {
  const index0 = directionList.indexOf(directionLike)
  const index1 = (index0 + directionList.length / 2) % directionList.length
  return directionList[index1]
}